module.exports = __webpack_public_path__ + "static/promo-text-4ac5f3c0b11298a3b0db8b1bf9e74a0b.svg";